const messages = {
  title: "Bericht erstellen",
  personal_data: {
    title: "Dati personali",
    email: "E-mail",
    salutation: "Titolo",
    first_name: "Nome",
    last_name: "Cognome",
    job_position: "Posizione in azienda",
  },
  shipping_address: {
    title: "Indirizzo di consegna",
    company: "Nome azienda",
    street: "Via e numero civico",
    postal_code: "CAP",
    mobile_phone: "Cellulare",
    iban_number: "IBAN",
    vat: "Partita IVA",
    additional_address: "Indirizzo aggiuntivo",
    city: "Città",
  },
  operating_data: {
    title: "Dati operativi",
    customer_number: "Numero cliente",
    group: "Gruppo",
    customer_group: "Gruppo",
    first_registration: "Prima registrazione",
    last_login: "Ultimo accesso",
    tires_per_year: "Pneumatici all'anno",
    over_18_inch: "Oltre 18 pollici",
    premium: "Premium",
    middle: "Medio",
    summer: "Estivi",
    winter: "Invernali",
    all_season: "Quattro stagioni",
  },
  calculated_data: {
    title: "Dati calcolati",
    tireAmount: "Quantità pneumatici",
    points: "Punti",
    bonus: "Bonus",
  },
  sales_structure: {
    title: "Struttura commerciale",
    sales_representative: {
      title: "Agente di vendita",
    },
    distributor: {
      title: "Distributore",
    },
  },
  meta: {
    title: "Metadati",
    brand: {
      title: "Marca",
      none: "",
    },
    tireType: {
      title: "Tipo di pneumatico",
      none: "",
    },
    year: {
      2020: "2020",
      2021: "2021",
      2022: "2022",
      2023: "2023",
      2024: "2024",
      2025: "2025",
      title: "Anno",
    },
    calendarMonth: {
      title: "Mese",
      january: "Gennaio",
      february: "Febbraio",
      march: "Marzo",
      april: "Aprile",
      may: "Maggio",
      june: "Giugno",
      july: "Luglio",
      august: "Agosto",
      september: "Settembre",
      october: "Ottobre",
      november: "Novembre",
      december: "Dicembre",
    },
  },
  selectAll: "Seleziona tutto",
  reset: "Reimposta filtri",
  generate: "Genera rapporto",
  loadingInfo: "Generazione del rapporto in corso, attendere prego...",
};

export default {
  messages,
};
